(function($)
{
	var sk = window.sk = {
		mediator: $({}),
		base: {},
		utils: {},
		widgets: {},
		events: {}
	};

	sk.extend = function(child, parent) {
		var F = function(){};
		F.prototype = parent.prototype;
		child.prototype = new F();
		child._super =  parent.prototype;
		child.prototype.constructor = child;
	};

})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/js/class/sk.js
// module id = 19
// module chunks = 0